import React from "react";
import moment from "moment";
import I18n from "i18n-js";

import Indicator from "./Indicator";

const formatDate = (date) => {
  const offsetDate = moment.utc(date).local().toDate();
  return I18n.l("date.formats.default", offsetDate);
}

const SimpleTimestep = ({ title, date }) => {

  const dateText = date ? formatDate(date) : I18n.t("pdp.timeline.not_started");

  return (
    <div className="timestep simple">
      <div className="indicator-wrapper">
        <Indicator task={{ status: date ? "completed" : "not_started" }} />
      </div>
      <div className="card">
        <div className="info">
          <div className="basic">
            <span className="title">{title}</span>
            <span className="date">{dateText}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SimpleTimestep;
